<div class="w-full">
  <div
    class="flex justify-between items-center py-7 cursor-pointer select-none border-b border-gray-300 group"
    role="button"
    tabindex="0"
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="toggle()"
  >
    <span
      class="text-lg font-medium font-sans leading-tight-sm text-blue-bright transition-colors duration-200 group-hover:text-blue-500"
    >
      {{ title }}
    </span>
    <i
      class="pi text-xl text-blue-darker transition-transform duration-300"
      [ngClass]="isExpanded ? 'pi-angle-up' : 'pi-angle-down'"
    ></i>
  </div>
  <div
    class="overflow-hidden max-h-0 transition-all duration-300"
    [class.max-h-expanded]="isExpanded"
  >
    @if (isExpanded) {
      <div class="py-4 flex flex-col gap-2.5">
        <ng-content></ng-content>
      </div>
    }
  </div>
</div>
